import {
  TooltipContent,
  TooltipProvider,
  Tooltip as TooltipRoot,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import * as React from "react";
import { isMobile } from "react-device-detect";

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  delayDuration?: number;
  className?: string;
  sideOffset?: number;
  side?: "top" | "right" | "bottom" | "left";
  asChild?: boolean;
  disabled?: boolean;
};

const Tooltip = ({
  children,
  content,
  className,
  sideOffset,
  side = "top",
  asChild,
  disabled,
  ...rootProps
}: TooltipProps) => {
  const [isMobileOpen, setIsMobileOpen] = React.useState(rootProps.open);

  const handleMobileClick = () => {
    if (isMobile) {
      setIsMobileOpen(!isMobileOpen);
    }
  };
  // Merge existing onClick with handleMobileClick
  const childrenWithProps = React.isValidElement(children)
    ? React.cloneElement(children, {
        onClick: (e: React.MouseEvent<HTMLElement>) => {
          // If the child has its own onClick, call it
          if ("onClick" in children.props && children.props.onClick) {
            children.props.onClick(e);
          }
          // Then call handleMobileClick
          handleMobileClick();
        },
      } as React.HTMLAttributes<HTMLElement>)
    : children;

  return disabled ? (
    children
  ) : (
    <TooltipProvider>
      <TooltipRoot
        {...rootProps}
        open={isMobile ? isMobileOpen : undefined}
        onOpenChange={isMobile ? setIsMobileOpen : rootProps.onOpenChange}
      >
        <TooltipTrigger asChild={asChild}>{childrenWithProps}</TooltipTrigger>
        <TooltipContent
          className={className}
          sideOffset={sideOffset}
          side={side}
        >
          {content}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
};

export default Tooltip;
